import {
  FrequencyInput,
  FormCard,
  FormItem,
  FormRadioGroup,
  Checkbox,
  DatePicker,
} from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { useTranslation } from 'react-i18next'
import { FC } from 'react'
import { RotaPatternModalType } from '../RotaPattern/utils'
import styled from 'styled-components'
import Divider from '@lmc/ui-kit/src/layout/Divider/Divider'
import { getRequiredRule } from '../utils'
import dayjs from 'dayjs'

type ReccurencePatternProps = {
  type?: RotaPatternModalType
  onFrequencyValueChange?: (value?: string) => void
  onIntervalValueChange?: (value?: number) => void
  onDaysValueChange?: (value?: string[]) => void
  frequencyValue?: string
  intervalValue?: number
  specificDaysValue?: string[]
  hasError?: boolean
  monthlyOptions?: { label: string; value: string | number }[]
  optimisticWeekStartDate?: number
  hasReoccurence?: boolean
  hasEndDate?: boolean
  minDate?: dayjs.Dayjs
}

const ReccurencePattern: FC<ReccurencePatternProps> = ({
  onFrequencyValueChange,
  onIntervalValueChange,
  onDaysValueChange,
  frequencyValue,
  intervalValue,
  specificDaysValue,
  hasError,
  monthlyOptions,
  optimisticWeekStartDate,
  hasReoccurence,
  hasEndDate,
  minDate,
}) => {
  const { t } = useTranslation()

  const options = [
    { label: 'Yes', value: true },
    { label: 'No, it is one-off', value: false },
  ]

  return (
    <FormCard level={2} title={t('RECURRENCE_PATTERN')}>
      <FormItem
        name="reoccurenceTooglePattern"
        label={<Text>{t('DOES_IT_REPEAT')}</Text>}
      >
        <StyleRadioGroup options={options} />
      </FormItem>
      {hasReoccurence && (
        <>
          <FrequencyInput
            monthlyOptions={monthlyOptions}
            label={<Text>{t('FREQUENCY')}</Text>}
            onChangeFrequency={(value) => {
              onFrequencyValueChange?.(value)
            }}
            onChangeIntervals={(value) => {
              onIntervalValueChange?.(value)
            }}
            onChangeDays={(value) => {
              onDaysValueChange?.(value)
            }}
            frequencyValue={frequencyValue}
            intervalValue={intervalValue}
            specificDaysValue={specificDaysValue}
            hasError={hasError}
            optimisticWeekStartDate={optimisticWeekStartDate}
          />
          <Divider />
          <FormItem name="hasPatternEndDate" valuePropName="checked">
            <Checkbox>
              <Text>{t('HAS_END_DATE')}</Text>
            </Checkbox>
          </FormItem>
          {hasEndDate && (
            <FormItem
              name="patternEnd"
              label={<Text>{t('END_DATE')}</Text>}
              rules={[getRequiredRule(t('END_DATE'))]}
            >
              <DatePicker minDate={minDate as dayjs.Dayjs} />
            </FormItem>
          )}
        </>
      )}
    </FormCard>
  )
}

const StyleRadioGroup = styled(FormRadioGroup)`
  .ant-radio-wrapper {
    width: unset;
    background-color: transparent !important;
    margin-left: -12px;
  }
`

export default ReccurencePattern
